// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vUPC","footer":"styles_footer__2t3Dy","passCodeTooltip":"styles_passCodeTooltip__21Ala"};